import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../../common/views/SMLButton/SMLButton';
import type { CoverPublicTool } from '../CoverEditorContext';
import { publicCoverMessages } from './publicCoverMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the cover editor; each part uses its own slice of it */
import editorStyles from '../CoverEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface KeepDesignCardProps {
  tool: CoverPublicTool;
}

/**
 * The card at the end of the inspector of the public tool (design cover-editor g1): a free account
 * keeps the design and makes it the cover of a song.
 */
const KeepDesignCardComponent: React.FC<KeepDesignCardProps> = ({ tool }) => {
  const intl = useIntl();
  return (
    <div className={editorStyles.lock}>
      <b>{intl.formatMessage(publicCoverMessages.keepTitle)}</b>
      <p>{intl.formatMessage(publicCoverMessages.keepText)}</p>
      <SMLButton size="sm" omitCap onClick={tool.onSignUp}>
        {intl.formatMessage(publicCoverMessages.signUp)}
      </SMLButton>
    </div>
  );
};

export const KeepDesignCard = TypedMemo(KeepDesignCardComponent);
